import React, { useEffect, useRef, useState } from 'react'
import jsQR from 'jsqr'
import { trans } from '../../_providers/Translation'

function QrScanner(props) {
    const videoRef = useRef(null)
    const canvasRef = useRef(null)
    const streamRef = useRef(null)
    const rafRef = useRef(null)

    const [error, setError] = useState(null)

    useEffect(() => {
        let cancelled = false

        const stopCamera = () => {
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current)
                rafRef.current = null
            }

            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop())
                streamRef.current = null
            }
        }

        const scan = () => {
            const video = videoRef.current
            const canvas = canvasRef.current

            if (video && canvas && video.readyState === video.HAVE_ENOUGH_DATA) {
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight

                const context = canvas.getContext('2d')
                context.drawImage(video, 0, 0, canvas.width, canvas.height)

                const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
                const code = jsQR(imageData.data, imageData.width, imageData.height)

                if (code && code.data) {
                    stopCamera()
                    props.onDetected(code.data)
                    return
                }
            }

            rafRef.current = requestAnimationFrame(scan)
        }

        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            setError('insecure')
            return () => {}
        }

        navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
            .then(stream => {
                if (cancelled) {
                    stream.getTracks().forEach(track => track.stop())
                    return
                }

                streamRef.current = stream

                if (videoRef.current) {
                    videoRef.current.srcObject = stream
                    videoRef.current.play()
                }

                rafRef.current = requestAnimationFrame(scan)
            })
            .catch(err => {
                console.error('QrScanner camera error:', err && err.name, err && err.message)
                if (!cancelled) setError((err && err.name) || 'unknown')
            })

        return () => {
            cancelled = true
            stopCamera()
        }
    }, [])

    const handleClose = e => {
        if (e) e.preventDefault()

        props.onClose()
    }

    return (
        <div className="overlay visible qr-scanner-overlay">
            <div className="qr-scanner-modal">
                <span className="close" onClick={handleClose}></span>

                {error
                    ?
                    <p className="qr-scanner-error">
                        {error === 'NotFoundError'
                            ? trans('filters.cameraNotFound')
                            : error === 'NotReadableError'
                                ? trans('filters.cameraInUse')
                                : trans('filters.cameraAccessDenied')
                        }
                    </p>
                    :
                    <div className="qr-scanner-video-holder">
                        <video ref={videoRef} muted playsInline />
                        <div className="qr-scanner-frame"></div>
                        <p>{trans('filters.pointCameraAtQr')}</p>
                    </div>
                }

                <canvas ref={canvasRef} style={{ display: 'none' }} />
            </div>
        </div>
    )
}

export default QrScanner
